import { AllvalueAdditionThreeResponse, ValueAdditionIdRequest, valueAdditionIdResponse, valueAdditionThreeResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAdditionThreeDTO } from './dto/value-addition-three.dto';
import { ValueAdditionThreeRequest } from './dto/value-addition-three.request';
import { ValueAddition3TypesService } from './value-addition3-types.service';

@ApiTags('value-addition3-types')
@Controller('value-addition3-types')
export class ValueAddition3TypesController {
    constructor(
        private valAddThreeTypeService: ValueAddition3TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

       /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/createValAddThreeType')
    async createValAddThreeType(@Body() valAddDto:ValueAdditionThreeDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionThreeResponse> {
        try {
         return await this.valAddThreeTypeService.createValAddThreeType(valAddDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionThreeResponse, error);
       }
     }

      /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllValAddTypes')
    async getAllValAddThreeTypes(@Body() req?:UserRequestDto): Promise<AllvalueAdditionThreeResponse> {
        try {
            return await this.valAddThreeTypeService.getAllValAddThreeTypes(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllvalueAdditionThreeResponse, error);
        }
    }

     /**
     * gets all the active Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

      @Post('/getAllAvtiveValAddThreeTypes')
      async getAllAvtiveValAddThreeTypes(): Promise<AllvalueAdditionThreeResponse> {
          try {
              return await this.valAddThreeTypeService.getAllAvtiveValAddThreeTypes();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllvalueAdditionThreeResponse, error);
          }
      }
    

     /**
     * Activate Or De-Activate Value AdditionThree Type
     * @param getSingleValAdditionTyoe AdditionThreeType 
     * @returns Value AdditionThreeTypeResponse
     */
   @Post('/activateOrDeactivateValAddThreeType')
   async activateOrDeactivateValAddThreeType(@Body() valAddThreeReq: ValueAdditionThreeRequest): Promise<valueAdditionThreeResponse> {
       try {
           return await this.valAddThreeTypeService.activateOrDeactivateValAddThreeType(valAddThreeReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(valueAdditionThreeResponse, err);
       }
   }

     /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
      @Post('/updateValAddThreeType')
      async updateValAddThreeType(@Body() valAddDto:ValueAdditionThreeDTO,isUpdate:boolean=true,@Req() request:Request): Promise<valueAdditionThreeResponse> {
          try {
           return await this.valAddThreeTypeService.createValAddThreeType(valAddDto,true,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(valueAdditionThreeResponse, error);
         }
       }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
    @Post('/getValAddDetails')
    async getValAddDetails(@Body() valAddOneReq: ValueAdditionIdRequest): Promise<valueAdditionIdResponse> {
        try {
            return await this.valAddThreeTypeService.getValAddDetails(valAddOneReq.valueAdditionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionIdResponse, error);
        }
    }
}
